// extracted by mini-css-extract-plugin
export default {"home":"home__0Fiqf","cardHeader":"cardHeader__SFyqi","cardBody":"cardBody__ZEFGs"};